import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./index.css";
import App from "./App";
import global_en from "./translations/en/global.json";
import global_ar from "./translations/ar/global.json";
import i18next from "i18next";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import store from "./redux/store";
i18next.init({
  lng: (localStorage.getItem('lang') || 'ar').replace(/"/g, ''),
  resources: {
    ar: {
      global: global_ar,
    },
    en: {
      global: global_en,
    },
  },
  ns: ["global"],
  defaultNS: "global"
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18next}>
    <Provider store={store}>
      <App />
    </Provider>
  </I18nextProvider>
);
